import React, { useState } from 'react'

interface TabProps<T> {
  children: React.ReactNode
  width: string
  value: T
  activeTab: string
  setActiveTab: React.Dispatch<React.SetStateAction<T>>
}

const Tab = function <T>({
  children,
  width,
  activeTab,
  value,
  setActiveTab,
}: TabProps<T>) {
  const isActive = activeTab === value

  const activeButtonProps = {
    border: '2px solid #7940B3',
    backgroundColor: '#7940B3',
    color: '#FFFFFF',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
  }

  const [isHovered, setIsHovered] = useState(false)

  const hoveredStyle = isHovered
    ? isActive
      ? { backgroundColor: '#904DD4' }
      : { backgroundColor: '#F2F2F2' }
    : {}

  return (
    <div
      style={{
        width,
        backgroundColor: '#F7F7F7',
        transition: 'all 0.15s ease',
        ...(isActive ? activeButtonProps : {}),
        ...hoveredStyle,
      }}
      className='flex justify-center items-center w-full border rounded-md cursor-pointer'
      onClick={() => setActiveTab(value)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div>{children}</div>
    </div>
  )
}

export default Tab
